import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Decorative stacked-bar illustration of how aid can reduce total cost.
 * Fixed proportions only — not school-specific costs.
 */
@Component({
  selector: 'app-aid-cost-illustration',
  standalone: true,
  templateUrl: './aid-cost-illustration.component.html',
  styleUrl: './aid-cost-illustration.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AidCostIllustrationComponent {
  @Input() title = 'How aid could reduce your cost';

  /** Longer description for screen readers (complements the visible title). */
  @Input() description =
    'Illustration only: grants and scholarships reduce the total cost of attendance, leaving an estimated net price.';

  readonly titleId = `aid-cost-illustration-title-${Math.random().toString(36).slice(2, 9)}`;
  readonly descId = `aid-cost-illustration-desc-${Math.random().toString(36).slice(2, 9)}`;
  readonly barClipId = `aid-cost-illustration-clip-${Math.random().toString(36).slice(2, 9)}`;
}
